<template>
  <div>
    <v-row no-gutters justify="center" align="start">
      <div class="n-container">
        <v-row no-gutters justify="start" align="start">
          <v-expand-x-transition>
            <div v-show="areFiltersOpened">
              <div class="side-content-medium ml-6">
                <v-row no-gutters align="center" class="content-header">
                  <v-icon small class="mr-2 pb-1">filter_list</v-icon>
                  <div class="font-weight-bold">Filtres</div>
                  <v-spacer></v-spacer>
                  <!-- <v-btn icon @click="areFiltersOpened = false">
                    <v-icon small>clear</v-icon>
                  </v-btn> -->
                </v-row>
                <n-card class="pt-2 pb-6">
                  <template v-if="isAggregator">
                    <div class="filter-item-title mt-4 px-4">
                      Prestataire
                    </div>
                    <div class="filter-item-content-list px-4">
                      <v-autocomplete
                        :items="makers"
                        v-model="maker"
                        single-line
                        solo
                        placeholder="Tous"
                        hide-details
                        item-text="name"
                        item-value="id"
                        clearable
                        flat
                        style="width: 100%;"
                        class="n-select mr-4"
                      ></v-autocomplete>
                    </div>
                  </template>
                  <template v-if="hasClientSelected">
                    <div class="filter-item-title mt-4 px-4">
                      Site
                    </div>
                    <div class="filter-item-content-list px-4">
                      <v-autocomplete
                        :items="sites"
                        v-model="site"
                        single-line
                        solo
                        placeholder="Tous"
                        hide-details
                        item-text="name"
                        item-value="id"
                        clearable
                        flat
                        height="36px"
                        style="width: 100%;"
                        class="n-select mr-4"
                      ></v-autocomplete>
                    </div>
                  </template>
                </n-card>
              </div>
            </div>
          </v-expand-x-transition>
          <v-col align="center" class="pa-0 mx-6">
            <v-row no-gutters align="center" class="content-header">
              <v-expand-x-transition>
                <div v-show="!areFiltersOpened">
                  <v-btn class="n-white-btn n-small-btn px-2 mr-2" @click="areFiltersOpened = true">
                    <v-icon small class="mr-2">filter_list</v-icon>
                    Filtrer
                  </v-btn>
                </div>
              </v-expand-x-transition>
              <span class="font-weight-bold">Statistiques</span>
              <v-spacer></v-spacer>
              <v-btn class="n-white-btn n-small-btn pl-5">
                2 derniers mois
                <v-icon>arrow_drop_down</v-icon>
              </v-btn>
            </v-row>
            <v-row no-gutters justify="center" align="center" v-if="isFetchingStatistics">
              <div style="margin-top: 20%; width: 250px;">
                <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
            </v-row>
            <div class="page-main-content" v-else>
              <v-row no-gutters justify="center" align="center" class="pb-4">
                <v-col cols="7" class="pr-2">
                  <n-card class="pa-2">
                    <timeline-chart
                      :from="from"
                      :to="to"
                      :interventions="interventions"
                    />
                  </n-card>
                </v-col>
                <v-col cols="5" class="pl-2">
                  <n-card class="pa-2">
                    <by-weekday-chart
                      :interventions="interventions"
                    />
                  </n-card>
                </v-col>
              </v-row>
              <n-card class="pa-2 mb-4">
                <by-maker-chart
                  :interventions="interventions"
                  :makers="makers"
                />
              </n-card>
              <n-card class="pa-2">
                <by-site-chart
                  :interventions="interventions"
                  :sites="sites"
                />
              </n-card>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import TimelineChart from '@/components/Statistics/TimelineChart.vue';
import ByWeekdayChart from '@/components/Statistics/ByWeekdayChart.vue';
import ByMakerChart from '@/components/Statistics/ByMakerChart.vue';
import BySiteChart from '@/components/Statistics/BySiteChart.vue';

export default {
  name: `Statistics`,

  data: () => ({
    areFiltersOpened: true,
    isFetchingStatistics: true,
  }),

  computed: {
    ...mapState(`model/client`, [`company`, `isAggregator`]),
    ...mapState(`model/user`, [`me`, `isMakerUser`, `isAggregatorUser`]),
    ...mapState(`ui/statistics`, [`interventions`, `sites`, `makers`]),
    from: {
      get() { return this.$store.state[`ui/statistics`].from; },
      set(from) { this.$store.commit(`ui/statistics/SET_FROM`, from); },
    },
    to: {
      get() { return this.$store.state[`ui/statistics`].to; },
      set(to) { this.$store.commit(`ui/statistics/SET_TO`, to); },
    },
    maker: {
      get() { return this.$store.state[`ui/statistics`].maker; },
      set(maker) { this.$store.commit(`ui/statistics/SET_MAKER`, maker); },
    },
    client: {
      get() { return this.$store.state[`ui/statistics`].client; },
      set(client) { this.$store.commit(`ui/statistics/SET_CLIENT`, client); },
    },
    site: {
      get() { return this.$store.state[`ui/statistics`].site; },
      set(site) { this.$store.commit(`ui/statistics/SET_SITE`, site); },
    },
    hasClientSelected() {
      return Boolean(this.client);
    },
  },

  methods: {
    fetchInterventions() {
      this.$store.dispatch(`ui/statistics/fetchInterventions`);
    },
    fetchSites() {
      this.$store.dispatch(`ui/statistics/fetchSites`);
    },
    async fetchUiDatas() {
      this.isFetchingStatistics = true;
      const promises = [
        this.fetchInterventions(),
      ];
      if (!this.isMaker) {
        promises.push(this.fetchSites());
      }
      if (this.isAggregator) {
        promises.push(this.$store.dispatch(`ui/statistics/fetchMakers`));
      } else {
        promises.push(this.$store.dispatch(`ui/statistics/fetchClients`));
      }
      await Promise.all(promises);
      this.isFetchingStatistics = false;
    },
  },

  beforeMount() {
    // if (!this.isMakerUser && !this.isAggregatorUser) {
    //   this.$store.commit(`ui/equipments/SET_CLIENT`, this.me.client.id);
    // }
    // this.setEquipmentIdFromRoute();
    // if (!this.equipmentId) {
    //   this.fetchUiDatas();
    // }
    this.from = moment().subtract(2, `months`).format(`YYYYMMDD`);
    this.to = moment().format(`YYYYMMDD`);
    if (this.isMaker) {
      this.maker = this.company.id;
    } else {
      this.client = this.company.id;
    }
    this.fetchUiDatas();
  },

  components: {
    TimelineChart,
    ByWeekdayChart,
    ByMakerChart,
    BySiteChart,
  },

  watch: {
    maker() { this.fetchInterventions(true); },
    site() { this.fetchInterventions(true); },
    // client() {
    //   if (this.hasClientSelected) {
    //     this.fetchSites();
    //   } else {
    //     this.site = null;
    //   }
    //   this.fetchEquipments(true);
    // },
    // site() { this.fetchEquipments(true); },
  },
};
</script>

<style lang="scss">
</style>
